/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ExtendedContextPreferences } from './extendedContextPreferences';
import { LoginRequestAccount } from './loginRequestAccount';
import { SignupIndividualRequest } from './signupIndividualRequest';
import { SignupIndividualRequestIndividual } from './signupIndividualRequestIndividual';

export interface CreateIndividualRequest extends SignupIndividualRequest { 
    is_admin?: boolean;
    notification_preferences?: Array<ExtendedContextPreferences>;
}